export const CART_ADD_REQUEST = 'CART_ADD_REQUEST';
export const CART_ADD_SUCCESS = 'CART_ADD_SUCCESS';
export const CART_ADD_FAIL = 'CART_ADD_FAIL';
export const CART_ADD_RESET = 'CART_ADD_RESET';